const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  console.error('La variable de entorno REACT_APP_API_BASE_URL no está definida');
}

export { API_BASE_URL };
